$(document).ready(function() {

    $('.open-search').click(function(e){
        e.preventDefault();
        $('.header-search').addClass('expand');
        $('.header-search').find('input').focus();
    });
    $('.search-close').click(function(e){
        e.preventDefault();
        $('.header-search').removeClass('expand');
        $('.header-search').find('input').val('');
        $("#suggesstion-box").fadeOut();
        $("#suggesstion-box").html(''); 
    });

});
